import { dataGridVariants } from './dataGridVariants'
import { presentationTableVariants } from './presentationTableVariants'
import { hierarchicalTableVariants } from './hierarchicalTableVariants'
import { hierarchicalGridVariants } from './hierarchicalGridVariants'
import { metricVariants } from './metricVariants'

const styleVariantRegistry = {
  'Data Grid': dataGridVariants,
  'Presentation Table': presentationTableVariants,
  'Hierarchical Table': hierarchicalTableVariants,
  'Hierarchical Grid': hierarchicalGridVariants,
  Metric: metricVariants
}

export function getVariantsForType (presentationType) {
  return styleVariantRegistry[presentationType] ?? {}
}

export function getVariantOptions (presentationType) {
  const variants = getVariantsForType(presentationType)
  return Object.values(variants).map(v => ({
    value: v.code,
    label: v.displayName,
    description: v.description
  }))
}

export function resolveVariant (presentationType, variantCode) {
  const variants = getVariantsForType(presentationType)
  return variants[variantCode] ?? variants.default ?? null
}

export function getVariantParameters (presentationType, variantCode) {
  const variant = resolveVariant(presentationType, variantCode)
  return variant?.parameters ?? []
}
